
export default {
  productcategories: []
}
